import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const fetchPropertyCommonAreasDone = (_,{ payload }) => {
  return payload;
}
const initialState = [];
export default createReducer(initialState, {
  [TYPES.FETCH_PROPERTY_COMMON_AREAS_DONE]:fetchPropertyCommonAreasDone
});